/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaCellNote from './AqaCellNote';

/**
 * The AqaNoteResponse model module.
 * @module model/AqaNoteResponse
 * @version v0
 */
export default class AqaNoteResponse {
  /**
   * Constructs a new <code>AqaNoteResponse</code>.
   * @alias module:model/AqaNoteResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaNoteResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaNoteResponse} obj Optional instance to populate.
   * @return {module:model/AqaNoteResponse} The populated <code>AqaNoteResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaNoteResponse();
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('note'))
        obj.note = AqaCellNote.constructFromObject(data['note']);
      if (data.hasOwnProperty('successful'))
        obj.successful = ApiClient.convertToType(data['successful'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} success
 */
AqaNoteResponse.prototype.success = undefined;

/**
 * @member {String} message
 */
AqaNoteResponse.prototype.message = undefined;

/**
 * @member {module:model/AqaCellNote} note
 */
AqaNoteResponse.prototype.note = undefined;

/**
 * @member {Boolean} successful
 */
AqaNoteResponse.prototype.successful = undefined;

